import { defineStore } from 'pinia';

export default defineStore('filter', {
  //persist: true,
  state: () => ({
    region: {
      id: 0,
      url: '',
    },
    district: {
      id: 0,
      url: '',
    },
    suburbs: [],
  }),
  actions: {
    setRegion(region) {
      this.region = region;
    },

    setDistrict(district) {
      this.district = district;
    },

    setSuburbs(suburbs) {
      this.suburbs = suburbs;
    },
  },
})
